import React from 'react';

const StatCard = ({ icon: Icon, label, value, comparison, bgColor = 'bg-white', highlight = false }) => {
  return (
    <div className={`${bgColor} rounded-xl p-4 border ${
      highlight ? 'border-emerald-500 shadow-lg' : 'border-gray-200 shadow-sm'
    }`}>
      {Icon && (
        <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-emerald-50 mb-3">
          <Icon size={20} className="text-emerald-600" />
        </div>
      )}
      <div>
        <p className="text-sm text-gray-500 mb-1">{label}</p>
        <p className="text-2xl font-bold text-gray-900">{value}</p>
        {comparison && (
          <p className="text-xs text-gray-500 mt-1">{comparison}</p>
        )}
      </div>
    </div>
  );
};

export default StatCard;
